import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../Utilities/Api";

class serverOwnApi {

    static addOwnQueueItem(ownCatalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `own/queue`,
                requestTypes.POST,
                JSON.stringify({ownCatalogItemId}),
                apiConstants.successMessage.queue.ADD,
            ),
        );
    }
}

export const ownApi = config.environment.MODE === config.modes.SERVER ? serverOwnApi : serverOwnApi;
